import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import classname from "classnames";

import { ItemType } from "../types";

import { Loader } from ".";

interface Props {
  data: ItemType;
  isSlideActive: boolean;
  setActiveContentRef: (ref: MutableRefObject<HTMLDivElement>) => void;
}

const ImageItem: React.FC<Props> = ({ data, isSlideActive, setActiveContentRef }) => {
  const { description, sizes, src, srcset } = data;

  const [shouldLoad, setShouldLoad] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const imgRef = useRef<HTMLImageElement>(null);

  const imgClasses = classname("lightbox__slide-item-img", {
    "lightbox__slide-item--loading": !isLoaded,
  });

  const handleOnLoad = (): void => {
    setIsLoaded(true);
  };

  /**
   * Set shouldLoad to true only in case slide is active
   * and do not change it on "false" when it was once setted to "true"
   * to prevent unnecessary loads - every load should happen only once
   */
  useEffect(() => {
    if (!isSlideActive || shouldLoad) return;

    setShouldLoad(true);
  }, [isSlideActive]);

  useEffect(() => {
    if (!isLoaded || !isSlideActive) return;

    setActiveContentRef(imgRef);
  }, [isSlideActive, isLoaded]);

  return (
    <>
      {!isLoaded && <Loader />}

      {(shouldLoad || isLoaded) && (
        <img
          className={imgClasses}
          ref={imgRef}
          draggable="false"
          src={src}
          alt={description}
          srcSet={srcset}
          sizes={sizes}
          onLoad={handleOnLoad}
        />
      )}
    </>
  );
};

export default ImageItem;
